// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__260zQ","icon":"Status_icon__2HxAM","text":"Status_text__2jIjC"};